class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
  
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }
  
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      })
    }
  
    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }
  
  customElements.define('details-disclosure', DetailsDisclosure);
  if (!customElements.get('share-button')) {
    customElements.define('share-button', class ShareButton extends DetailsDisclosure {
      constructor() {
        super();
  
        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input')
        }
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
  
        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
        }
      }
  
      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }
  
      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }
  
      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    });
  }

  class CartNotification extends HTMLElement {
    constructor() {
      super();
  
      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header');
      this.onBodyClick = this.handleBodyClick.bind(this);
      
      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }
  
    open() {
      this.notification.classList.add('animate', 'active');
  
      this.notification.addEventListener('transitionend', () => {
        this.notification.focus();
        trapFocus(this.notification);
      }, { once: true });
  
      document.body.addEventListener('click', this.onBodyClick);
    }
  
    close() {
      this.notification.classList.remove('active');
  
      document.body.removeEventListener('click', this.onBodyClick);
  
      removeTrapFocus(this.activeElement);
    }
  
    renderContents(parsedState) {
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));
  
        if (this.header) this.header.reveal();
        this.open();
    }
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-product',
          selector: `#cart-notification-product-${this.productId}`,
        },
        {
          id: 'cart-notification-button'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }
  
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleBodyClick(evt) {
      const target = evt.target;
      if (target !== this.notification && !target.closest('cart-notification')) {
        const disclosure = target.closest('details-disclosure');
        this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
        this.close();
      }
    }
    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  // Coupon copy button + coupon code ticket
  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('coupon_copy');
    const codeEl = document.getElementById('coupon_code');
    if (!btn && !codeEl) return;

    // Shared copy helper (Clipboard API + fallback)
    async function copyText(text) {
      if (!text) return false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          return true;
        }
      } catch (e) {
        // fallback below
      }

      try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        ta.style.top = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
      } catch (e) {
        return false;
      }
    }

    function getCouponCodeFromButton(buttonEl) {
      // User markup uses attribute: data="YRENDSALE20"
      return (
        buttonEl.getAttribute('data') ||
        buttonEl.getAttribute('data-code') ||
        (buttonEl.dataset ? (buttonEl.dataset.code || buttonEl.dataset.coupon) : '') ||
        ''
      ).trim();
    }

    // Handle button (#coupon_copy) if present
    if (btn) {
      const originalText = (btn.textContent || '').trim() || 'Copy';

      // Build icon + label inside the button (so we can animate it)
      btn.innerHTML = `
        <span class="coupon-copy-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M7 7.5h10M7 12h10M7 16.5h7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M6.5 3h11A2.5 2.5 0 0 1 20 5.5v13A2.5 2.5 0 0 1 17.5 21h-11A2.5 2.5 0 0 1 4 18.5v-13A2.5 2.5 0 0 1 6.5 3Z" stroke="currentColor" stroke-width="2"/>
            <path d="M18 8.5a2 2 0 1 0 0-4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="coupon-copy-label"></span>
      `;
      const labelEl = btn.querySelector('.coupon-copy-label');
      if (labelEl) labelEl.textContent = originalText;

      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        const code = getCouponCodeFromButton(btn);
        if (!code) return;

        btn.classList.remove('coupon-copy-done');
        btn.classList.add('coupon-copy-anim');
        if (labelEl) labelEl.textContent = 'Copying';

        const ok = await copyText(code);
        if (!ok) return;

        setTimeout(function () {
          btn.classList.remove('coupon-copy-anim');
          btn.classList.add('coupon-copy-done');
          if (labelEl) labelEl.textContent = 'Copied';
        }, 450);
      });
    }

    // Handle coupon code ticket (#coupon_code) if present
    if (codeEl) {
      codeEl.setAttribute('role', 'button');
      codeEl.setAttribute('tabindex', '0');
      codeEl.setAttribute('aria-label', 'Copy coupon code');

      // Upgrade markup to include a premium icon affordance (no "Copy" text)
      if (!codeEl.querySelector('.coupon-code-text')) {
        const codeValue = (codeEl.textContent || '').trim();
        codeEl.innerHTML = `
          <span class="coupon-code-text"></span>
          <span class="coupon-code-icon" aria-hidden="true">
            <svg class="icon-copy" viewBox="0 0 24 24" fill="none">
              <path d="M9 9h10v12H9V9Z" stroke="currentColor" stroke-width="2" />
              <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <svg class="icon-check" viewBox="0 0 24 24" fill="none">
              <path d="M20 7L10 17l-4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        `;
        const textEl = codeEl.querySelector('.coupon-code-text');
        if (textEl) textEl.textContent = codeValue;
        codeEl.dataset.couponValue = codeValue;
      }

      const runCopy = async function () {
        const code = (codeEl.dataset && codeEl.dataset.couponValue) ? codeEl.dataset.couponValue : (codeEl.textContent || '').trim();
        if (!code) return;

        codeEl.classList.remove('is-copied');
        codeEl.classList.add('is-copying');

        const ok = await copyText(code);
        if (!ok) return;

        codeEl.classList.remove('is-copying');
        codeEl.classList.add('is-copied');

        // Toast message on top-right of the coupon section
        const offersBox = codeEl.closest('.offers-wraper');
        if (offersBox) {
          const existing = offersBox.querySelector('.coupon-toast');
          if (existing) existing.remove();
          const toast = document.createElement('div');
          toast.className = 'coupon-toast';
          toast.innerHTML = `
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M20 7L10 17l-4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Copied
          `;
          offersBox.appendChild(toast);
          setTimeout(function () { toast.remove(); }, 1400);
        }

        setTimeout(function () {
          codeEl.classList.remove('is-copied');
        }, 1400);
      };

      codeEl.addEventListener('click', function (e) {
        e.preventDefault();
        runCopy();
      });

      codeEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          runCopy();
        }
      });
    }
  });


  customElements.define('cart-notification', CartNotification);  

$(document).ready( function(e){
  let window_width = $(window).width();
  if(window_width >= 993){
    $('img.magnifier-img').each(function(e){
      if(window_width >= 1600){
        $(this).attr('src', $(this).attr('img_1600'));
      }
      else if(window_width >= 1400){
        $(this).attr('src', $(this).attr('img_1400'));
      }
      else if(window_width >= 1200){
        $(this).attr('src', $(this).attr('img_1200'));
      }
      else if(window_width >= 992){
        $(this).attr('src', $(this).attr('img_992'));
      }
    });
    var evt = new Event_M(),
    m = new Magnifier(evt);
    $product_magnifier_wrapper = $("#product_magnifier_wrapper");
    m.attach({
      thumb: '.magnifier-img',
      largeWrapper: 'product_magnifier_wrapper', 
      zoom: 2,
      //zoomable: true,
      onthumbenter: function () {
        $product_magnifier_wrapper.css({'display':'block','background':'#fff','z-index': '99'});
      },
      onthumbleave: function () {
        $product_magnifier_wrapper.css('display', 'none'); 
      }
    });
    setTimeout(function(e){
      let magnifier_lens_h = $(".magnifier-lens").first().height();
      let magnifier_lens_w= $(".magnifier-lens").first().width();
      $('.magnifier-lens').each(function(index){
        $(this).height(magnifier_lens_h);
        $(this).width(magnifier_lens_w);
      });
    },2000);
  }
});